module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"products":"Artikel","theQuantityhasToBeAtLeast":"Die Menge muss mindestens {min} betragen.","period1":"Zeitraum 1","period2":"Zeitraum 2","search":"Suchen"},"en":{"products":"Products","theQuantityhasToBeAtLeast":"The quanitty has to be at least {min}.","period1":"Period 1","period2":"Period 2","search":"Search"}}')
  delete Component.options._Ctor
}
